import { $themeBreakpoints } from '@themeConfig'
import axios from '@/components/axios'
import Vue from 'vue'
import { matchRouteToModule, getRouteType, checkUserRoutePermission, hasAnyModulePermission } from '@/libs/acl/routePermission'
export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    priorityData: {},
    shallShowOverlay: false,
    timer: null,
    user_data: {},
    all_users: [],
    user_approval: [],
    user_widgets: [],
    showHideData: {},
    customerDetailsModal: false,
    customerDetails: {
      data: {},
      loading: false,
      success: false,
      error: null,
    },
    modulesData: [],
    user_module_routes: [],
    user_route_permissions_cache: {},
    accessToken: localStorage.getItem("accessToken"),
    baseApi: process.env.VUE_APP_APIENDPOINT,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    approvalAccess: (state) => (title) => {
      let arr = state.user_approval.filter((item) => item.module?.name == title)
      return arr.length > 0;
    },
    widgetAccess: (state) => (name) => {
      const ud =
        state.user_data && Object.keys(state.user_data).length
          ? state.user_data
          : (() => {
              try {
                return JSON.parse(localStorage.getItem('userData') || '{}');
              } catch (e) {
                return {};
              }
            })();
      const role = String(ud?.role || '').toLowerCase();
      const typ = String(ud?.type || '').toLowerCase();
      if (role === 'admin' || typ === 'admin') {
        return true;
      }
      return state.user_widgets.some((item) => {
        return (
          item &&
          item.name === name &&
          (item.view === 1 || item.view === true || item.view === '1')
        );
      });
    },
    getModulesData: (state) => state.modulesData || [],
    getModuleByRoute: (state) => (routePath) => {
      return matchRouteToModule(routePath, state.modulesData || []);
    },
    getUserRightsForModule: () => (moduleName) => {
      const rights = JSON.parse(localStorage.getItem('UserRights') || '[]');
      return rights.find(r => (r.modulename || '').toLowerCase() === (moduleName || '').toLowerCase());
    },
    hasRoutePermission: (state, getters) => (moduleName, routeType) => {
      const rights = getters.getUserRightsForModule(moduleName);
      if (!rights) return false;
      if (routeType === 'listing') return hasAnyModulePermission(rights);
      return checkUserRoutePermission([rights], moduleName, routeType);
    },
    hasModuleAccess: (state, getters) => (moduleName) => {
      const rights = getters.getUserRightsForModule(moduleName);
      return hasAnyModulePermission(rights || {});
    },
  },
  mutations: {
    saveState(state) {
      if (state) {
        state.customerDetailsModal = false
        state.customerDetails = {
          data: {},
          loading: false,
          success: false,
          error: null,
        },
          localStorage.setItem('vuex-state', JSON.stringify(state));
      }
    },
    loadState(state) {
      const localState = localStorage.getItem('vuex-state');
      if (localState) {
        Object.assign(state, JSON.parse(localState));
        localStorage.removeItem('vuex-state');
      }
    },
    SET_USERS(state, val) {
      state.all_users = val
    },

    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_USER_DATA(state, val) {
      state.user_data = val
    },
    SET_APPROVAL_DATA(state, val) {
      state.user_approval = val
    },
    SET_WIDGET_DATA(state, val) {
      state.user_widgets = val
    },
    SET_CUSTOMER_MODAL(state) {
      state.customerDetailsModal = !state.customerDetailsModal
    },
    SET_CUSTOMER_DETAILS(state, val) {
      state.customerDetails.data = val
    },
    SET_CUSTOMER_LOADING(state, val) {
      state.customerDetails.loading = val
    },
    SET_CUSTOMER_SUCCESS(state, val) {
      state.customerDetails.success = val
    },
    SET_CUSTOMER_ERROR(state, val) {
      state.customerDetails.error = val
    },
    UPDATE_SHOW_HIDE_DATA(state, payload) {
      Vue.set(state.showHideData, payload.key, payload.value);
    },
    SET_MODULES_DATA(state, modules) {
      state.modulesData = modules || [];
    },
    SET_USER_ROUTE_PERMISSIONS_CACHE(state, cache) {
      state.user_route_permissions_cache = cache || {};
    }
  },
  actions: {
    updateShowHideData({ commit }, payload) {

      commit('UPDATE_SHOW_HIDE_DATA', payload);
    },
    async getUserData(context) {

      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      let id = 0
      if (localStorage.getItem('userData')) {
        id = JSON.parse(localStorage.getItem('userData')).id
      }
      const reportauthority = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        url: `${baseApi}/getusersbyid/${id}`,
      };
      await axios(reportauthority)
        .then((response) => {
          const userData = response.data.data[0];
          context.commit('SET_USER_DATA', userData);
          
          // Update localStorage with the fetched user data (includes original_user_name if impersonating)
          if (userData) {
            // Merge with existing userData to preserve token and other login data
            const existingUserData = JSON.parse(localStorage.getItem('userData') || '{}');
            const updatedUserData = { ...existingUserData, ...userData };
            localStorage.setItem('userData', JSON.stringify(updatedUserData));
            
            // Store originalUserData if impersonating
            if (userData.original_user_name) {
              const originalUserData = {
                id: userData.parent?.id || null,
                name: userData.original_user_name,
                username: userData.parent?.username || null,
                role: userData.original_user_role,
                fullName: userData.original_user_name,
              };
              localStorage.setItem("originalUserData", JSON.stringify(originalUserData));
              
              // Trigger event to update UserDropdown component
              // Dispatch custom event on window (UserDropdown listens for this)
              window.dispatchEvent(new Event('userDataUpdated'));
            }
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async getApprovals(context) {

      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;

      const reportauthority = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        url: `${baseApi}/getApprovalsByUser`,
      };
      await axios(reportauthority)
        .then((response) => {
          context.commit('SET_APPROVAL_DATA', response.data.data)
        })
        .catch((error) => console.log(error, "error"));
    },
    async getWidgetRights(context) {

      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const id = JSON.parse(localStorage.getItem('userData')).id

      const data = {
        type: 'dynamic',
        id
      }
      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        url: `${baseApi}/getwidgetrights`,
        data: data
      };
      await axios(reportauthority)
        .then((response) => {
          const raw = response.data.data;
          let widgets = [];
          if (Array.isArray(raw)) {
            widgets = raw;
          } else if (raw && typeof raw === 'string' && raw.trim()) {
            try {
              widgets = JSON.parse(raw);
            } catch (e) {
              widgets = [];
            }
          } else if (raw && typeof raw === 'object') {
            widgets = Object.values(raw).flat();
          }
          context.commit('SET_WIDGET_DATA', Array.isArray(widgets) ? widgets : []);
        })
        .catch((error) => console.log(error, "error"));
    },
    async getCustomerDetails(context, payload) {

      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      if (payload) {
        context.commit('SET_CUSTOMER_LOADING', true);
        context.commit('SET_CUSTOMER_SUCCESS', false);
        context.commit('SET_CUSTOMER_ERROR', null);
        context.commit('SET_CUSTOMER_DETAILS', {});
        context.state.customerDetailsModal = !context.state.customerDetailsModal

        if (context.state.customerDetailsModal) {
          const reportauthority = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            url: `${baseApi}/customer-details/${payload.id}`,
          };
          await axios(reportauthority)
            .then((response) => {
              context.commit('SET_CUSTOMER_DETAILS', response.data.data)
              context.commit('SET_CUSTOMER_SUCCESS', true);

            })
            .catch((error) => {
              context.commit('SET_CUSTOMER_ERROR', error.response.data.message || 'Failed to fetch data');
            })
            .finally(() => {
              context.commit('SET_CUSTOMER_LOADING', false);
            });

        }

      }

    },
    async fetchModulesData({ state, commit }) {
      if (state.modulesData && state.modulesData.length) {
        return state.modulesData;
      }
      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        url: `${baseApi}/getmodules`,
      };
      return axios(requestOptions)
        .then((response) => {
          const modules = response.data.data?.data || response.data.data || [];
          commit('SET_MODULES_DATA', modules);
          return modules;
        })
        .catch(() => {
          commit('SET_MODULES_DATA', []);
          return [];
        });
    },
    async checkRouteAccess({ dispatch, getters }, { routePath, routeName }) {
      const modules = await dispatch('fetchModulesData');
      if (!modules || !modules.length) return false;
      const module = matchRouteToModule(routePath, modules);
      if (!module) return false;
      const routeType = getRouteType(routePath, routeName);
      return getters.hasRoutePermission(module.name, routeType);
    }
  }
}
